export default function RequestError({ children, className }: { children: React.ReactNode, className?: string }) {
  return (
    <span className={`inline-block m-1 mt-4 text-sm text-red-500 ${className ?? ''}`} >{children}</span>
  )
};